import Marquee from "react-fast-marquee";
import { useI18n } from "../i18n";

export const Ribbon = () => {
  const { t } = useI18n();
  const words = t("ribbon");

  return (
    <div
      data-testid="marquee-ribbon"
      className="py-8 border-y border-cyan-500/10 bg-[#070809] overflow-hidden"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-700 uppercase text-5xl md:text-7xl tracking-tighter outline-text px-8">
              {w}
            </span>
            <span className="text-cyan text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
};
